export default {
	properties: [
		{
			text: 'Titulo',
			key: 'title',
			type: 'text',
			value: '',
			is_title: true,
		},
		{
			text: 'Contenido',
			key: 'content',
			type: 'texteditor',
		},
	],
	singular_model_name_spanish: 'Descripcion',
	plural_model_name_spanish: 'Descripciones',
	create_model_name_spanish: 'Nueva',
	text_delete: 'la',
}